'use strict';
const	StoreFactory	= require('factories/Store')
		, LocalStorage	= require('providers/LocalStorageProvider')
		, CommonHelper	= require('peons/Common')
		, Q				= require('peons/Q')
		, Config		= require('main.config')
		;

module.exports = StoreFactory.create({
	displayName : 'Google',
	actions : [
		'init',
		'login_status',
		'response',
		'user_data'
	],
	methods : {
		__login : function(defer) {
			this.GoogleAuth.signIn().then((result)=>{
				let userdata = this.GoogleAuth.currentUser.get();
				this.dispatch({
					type : 'GOOGLE_LOGIN_STATUS',
					payload : true
				});

				this.dispatch({
					type : 'GOOGLE_RESPONSE',
					payload : result
				});

				defer &&
				defer.resolve(userdata);

			},(error)=>{
				//TODO : NOTIFICATION ERROR
				defer &&
				defer.reject(error);
			});
		},
		login : function(){
			return Q.suspend((defer)=>{
				if(this.state.init === 'ready') {
					if(this.state.loginStatus === false) {
						if(this.onInit) {
							this.onInit(defer)
						} else {
							this.__login(defer)
						}
					} else if(this.state.loginStatus === 'connected' || this.state.loginStatus === true) {
						defer.resolve(this.state.response)
					}
				} else {
					let _defer = defer;
					this.onInit = (defer)=>{
						this.__login(_defer);
					}
				}
			})
		},
		getUserData : function(){
			return Q.suspend((defer)=>{
				if(this.state.init === 'ready' && this.state.loginStatus === true) {
					let profile = this.GoogleAuth.currentUser.get();
					let userdata = profile.getBasicProfile();
					let accessToken = profile.getAuthResponse(true).access_token;


					userdata = {
						id : userdata.getId(),
						name : userdata.getName(),
						email : userdata.getEmail(),
						access_token: accessToken || null,
					}

					this.dispatch({
						type : 'GOOGLE_LOGIN_STATUS',
						payload : true
					})

					this.dispatch({
						type : 'GOOGLE_USER_DATA',
						payload : userdata
					})

					defer.resolve(userdata);
				} else {
					defer.reject('Login first!')
				}
			})
		}
	},
	construct : function(){

		this.GoogleAuth;

		if(CommonHelper.isWindow() && this.state.init !== 'ready') {
			if(this.state.init === false) {
				this.dispatch({
					type : 'GOOGLE_INIT',
					payload : 'pending'
				})

				window.googleAsyncInit = ()=>{
					gapi.load('auth2',()=>{
						this.GoogleAuth = google.accounts.oauth2.initTokenClient({
							client_id : Config.googleClientId,
							scope: 'https://www.googleapis.com/auth/userinfo.email',
							callback: (tokenResponse) => {
								if (callback) callback(tokenResponse);
							}
						})

						this.dispatch({
							type : 'GOOGLE_LOGIN_STATUS',
							payload : this.GoogleAuth.isSignedIn.get()
						})

						this.dispatch({
							type : 'GOOGLE_INIT',
							payload : 'ready'
						})

						this.onInit && typeof this.onInit === 'function' && this.onInit();
					})
				}

				//LOAD THE SDK
				(function(d, s, id) {
					var js, fjs = d.getElementsByTagName(s)[0];
					if (d.getElementById(id)) return;
					js = d.createElement(s); js.id = id;
					js.src = 'https://accounts.google.com/gsi/client';
					fjs.parentNode.insertBefore(js, fjs);
				}(document, 'script', 'google-jssdk'));
			}
		}
	},
	reducer : function(state,action) {
		switch(action.type) {
		case 'GOOGLE_USER_DATA' :
			return Object.assign({},state,{
				user : action.payload
			})

		case 'GOOGLE_RESPONSE' :
			return Object.assign({},state,{
				response : action.payload
			})

		case 'GOOGLE_LOGIN_STATUS' :
			return Object.assign({},state,{
				loginStatus : action.payload
			})

		case 'GOOGLE_INIT' :
			return Object.assign({},state,{
				init : action.payload
			})

		default :
			return state || {
				init : false,
				loginStatus : false,
				response : false,
				user : false
			};
		}
	}
})



// WEBPACK FOOTER //
// providers/stores/Google.js